import { Component, OnInit } from '@angular/core';
import { ApiJSONService, DomainBrandService, SeoService } from '@services/index';
import { BrandsInterface } from '@interfaces/index';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import * as ownActions from '@redux/actions';
@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss'],
})
export class BrandsComponent implements OnInit {
  data: BrandsInterface;
  dataHeader: any = [];
  dataBrands: any = [];
  dataProducts: any = [];

  constructor(
    private _apiJSONService: ApiJSONService,
    private _store: Store<AppState>,
    private _domainBrand: DomainBrandService,
    private _seo: SeoService
  ) {}

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.getData();
  }


  /**
   * -------------------------------------------------------
   * @summary getData
   * @description Retorna la data page - home
   * -------------------------------------------------------
   */
  async getData() {
    await this._apiJSONService
      .getJSONBrands('../assets/data/brands.json')
      .subscribe(
        (resp) => {
          this.data = resp;
          this.dataHeader = this.data.header;
          this.dataBrands = this.data.brands;
          this.dataProducts = this.data.products;
          const browser = this.data.browser?.[0];
          const pageTitle = browser?.title
            ? `${browser.title} | ${this._domainBrand.documentTitle}`
            : this._domainBrand.documentTitle;
          this._seo.setPageMeta({
            title: pageTitle,
            description: browser?.description || undefined,
          });
          this._store.dispatch(ownActions.setLoading({ loading: false }));
        },
        (error) => {
          this._store.dispatch(ownActions.setLoading({ loading: true }));
          console.log(`error`, error);
        },
        () => {
        }
      );
  }

}
